export const aboutData = {
  brand: {
    title: "关于91官网",
    subtitle: "官方正版入口 · 安全认证平台",
    description: [
      `91官网是91平台指定的唯一官方认证入口网站，致力于为广大用户提供安全、便捷、稳定的访问服务。自成立以来，我们始终坚持"用户至上、安全第一"的服务理念，不断优化平台功能和用户体验。`,
      "作为官方认证平台，91官网承担着重要的安全防护职责。我们建立了完善的安全监测体系，实时识别和拦截各类钓鱼网站和恶意攻击，确保用户每一次访问都是安全可靠的。",
      "我们的团队由资深网络安全专家、产品研发工程师和客户服务专员组成，从技术防护、产品优化到用户支持，全方位保障平台的安全稳定运行。",
    ],
    imageSeq: "about-brand",
  },
  reputation: {
    title: "平台信誉与资质",
    items: [
      {
        id: 1,
        icon: "ri-verified-badge-line",
        title: "合法合规运营",
        description: "严格遵循国家法律法规，持有完整的经营许可和行业资质，定期接受监管部门的审查与指导。",
      },
      {
        id: 2,
        icon: "ri-shield-star-line",
        title: "信息安全认证",
        description: "通过国际权威信息安全标准认证，采用银行级数据加密技术，全面保护用户隐私和数据安全。",
      },
      {
        id: 3,
        icon: "ri-user-star-line",
        title: "千万用户信赖",
        description: "累计服务超过1000万用户，凭借稳定可靠的服务质量赢得了广泛的市场认可和用户口碑。",
      },
      {
        id: 4,
        icon: "ri-award-line",
        title: "行业荣誉奖项",
        description: "多次获得行业协会颁发的优秀平台、最佳安全实践等荣誉称号，专业实力获得业界肯定。",
      },
      {
        id: 5,
        icon: "ri-hand-heart-line",
        title: "社会责任担当",
        description: "积极履行企业社会责任，参与网络安全公益宣传，帮助公众提升网络安全意识和防护能力。",
      },
      {
        id: 6,
        icon: "ri-team-line",
        title: "专业团队保障",
        description: "核心团队平均从业经验超过10年，涵盖网络安全、产品研发、客户服务等专业领域。",
      },
    ],
  },
  contact: {
    title: "联系我们",
    description: "如果您在使用过程中遇到任何问题，或有任何意见和建议，欢迎通过以下方式与我们取得联系。",
    email: "support@91guanwang.com",
    phone: "400-XXX-XXXX",
    workingHours: "工作日 9:00 - 18:00（北京时间）",
    address: "中国",
    socialLinks: [
      { id: 1, name: "官方微博", icon: "ri-weibo-line", url: "#" },
      { id: 2, name: "微信公众号", icon: "ri-wechat-line", url: "#" },
      { id: 3, name: "官方邮箱", icon: "ri-mail-line", url: "mailto:support@91guanwang.com" },
    ],
  },
};